'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var fieldLabel = require('./field-label-4ed9b7f8.js');
var nativeSelect_styles = require('./native-select.styles-3602a739.js');
var options = require('./options-2d7a1544.js');
var selectWrapper = require('./select-wrapper-29f937a6.js');

var NativeSelect = function (_a) {
    var className = _a.className, items = _a.items, placeholder = _a.placeholder, label = _a.label, required = _a.required, name = _a.name, value = _a.value, handleChange = _a.onChange, dataCy = _a.dataCy, dataTestId = _a.dataTestId;
    var isSelected = value != null;
    return (React__default.createElement(nativeSelect_styles.FieldWrapper, { className: className, "data-cy": dataCy, "data-testid": dataTestId },
        React__default.createElement(fieldLabel.FieldLabel, { className: "select-label", label: label, required: required, htmlFor: name, dataCy: "select-label", dataTestId: "select-label" }),
        React__default.createElement(selectWrapper.SelectWrapper, { value: value, isSelected: isSelected, onChange: handleChange, required: required, name: name },
            !isSelected && (React__default.createElement("option", { value: "", hidden: true, disabled: true, "data-cy": "placeholder", "data-testid": "placeholder" }, placeholder)),
            React__default.createElement(options.Options, { items: items }))));
};

exports.NativeSelect = NativeSelect;
